import type { SVGProps } from 'react';

const SvgUser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <circle
      cx={4}
      cy={4}
      r={4}
      fill="#000"
      stroke="#000"
      strokeWidth={1.5}
      transform="matrix(-1 0 0 1 16 4)"
    />
    <path
      fill="#000"
      stroke="#000"
      strokeWidth={1.5}
      d="M5 17.935c0-.86.54-1.628 1.351-1.918a16.8 16.8 0 0 1 11.298 0A2.04 2.04 0 0 1 19 17.935v1.315c0 1.188-1.052 2.1-2.227 1.932l-.955-.136a27 27 0 0 0-7.636 0l-.955.136A1.95 1.95 0 0 1 5 19.25z"
    />
  </svg>
);
export default SvgUser;
